import { withInstall } from '../utils/index';
import Container from './index.vue';
import Row from './row.vue';
import Col from './col.vue';
import './index.less';

export const TlbsContainer = withInstall(Container);
export const TlbsRow = withInstall(Row);
export const TlbsCol = withInstall(Col);
export default TlbsContainer;
